(function($) {
  if (!$) {
    return;
  }

  var activeFilterGroup = null;
  var storageKey = 'mcActiveFilterGroup';
  var transitionBuffer = 60;
  var fixedFilterMinWidth = 992;
  var fixedFilterFrame = null;

  function rememberFilterGroup(group) {
    activeFilterGroup = group || null;

    try {
      if (activeFilterGroup) {
        window.sessionStorage.setItem(storageKey, activeFilterGroup);
      } else {
        window.sessionStorage.removeItem(storageKey);
      }
    } catch (error) {
      // sessionStorage may be unavailable in some privacy modes.
    }
  }

  function getRememberedFilterGroup() {
    if (activeFilterGroup) {
      return activeFilterGroup;
    }

    try {
      return window.sessionStorage.getItem(storageKey);
    } catch (error) {
      return null;
    }
  }

  function getPanel(group) {
    var selector = '.mcFilterPanel[data-filter-group="' + group + '"]';

    if (window.matchMedia && window.matchMedia('(max-width: 991px)').matches) {
      return $('#sidebarAjaxFilter.mcFilter .mcFilterMobileGroups ' + selector);
    }

    return $('#sidebarAjaxFilter.mcFilter .mcFilterDrawer > .mcFilterPanels > ' + selector);
  }

  function getTrigger(group) {
    var selector = '.ajaxFilterTitle[data-filter-group="' + group + '"]';

    if (window.matchMedia && window.matchMedia('(max-width: 991px)').matches) {
      return $('#sidebarAjaxFilter.mcFilter .mcFilterMobileGroups ' + selector);
    }

    return $('#sidebarAjaxFilter.mcFilter .mcFilterGroups ' + selector);
  }

  function setPanelHeight($panel) {
    var list = $panel.find('.listFilter').first();

    if (list.length) {
      $panel.get(0).style.maxHeight = Math.ceil(list.outerHeight(true)) + 'px';
    }
  }

  function closePanel($panel) {
    var group = $panel.data('filter-group');
    var panel = $panel.get(0);
    var list = $panel.find('.listFilter').first();

    if (!panel || !list.length || !$panel.hasClass('is-open')) {
      return;
    }

    panel.style.maxHeight = Math.ceil(list.outerHeight(true)) + 'px';
    panel.offsetHeight;
    $panel.removeClass('is-open');
    getTrigger(group).removeClass('is-open').attr('aria-expanded', 'false');
    panel.style.maxHeight = '0px';
    syncFixedFilterRowSoon();
  }

  function openPanel($panel, instant) {
    var group = $panel.data('filter-group');
    var panel = $panel.get(0);

    if (!panel) {
      return;
    }

    $panel
      .closest('#sidebarAjaxFilter')
      .find('.mcFilterPanel.is-open')
      .not($panel)
      .each(function() {
        closePanel($(this));
      });

    getTrigger(group).addClass('is-open').attr('aria-expanded', 'true');
    $panel.addClass('is-open');

    if (instant) {
      panel.style.transition = 'none';
      setPanelHeight($panel);
      panel.offsetHeight;
      panel.style.transition = '';
      syncFixedFilterRowSoon();
      return;
    }

    panel.style.maxHeight = '0px';
    panel.offsetHeight;
    setPanelHeight($panel);
    syncFixedFilterRowSoon();
  }

  function closeAllPanels() {
    $('#sidebarAjaxFilter.mcFilter .mcFilterPanel.is-open').each(function() {
      closePanel($(this));
    });
    $('#sidebarAjaxFilter.mcFilter .ajaxFilterTitle.is-open').removeClass('is-open').attr('aria-expanded', 'false');
    syncFixedFilterRowSoon();
  }

  function openDrawer() {
    $('#sidebarAjaxFilter.mcFilter')
      .addClass('is-drawer-open')
      .find('.mcFilterMobileToggle')
      .attr('aria-expanded', 'true')
      .end()
      .find('.mcFilterDrawer')
      .attr('aria-hidden', 'false');
    $('body').addClass('mc-filter-drawer-open');
  }

  function closeDrawer() {
    $('#sidebarAjaxFilter.mcFilter')
      .removeClass('is-drawer-open')
      .find('.mcFilterMobileToggle')
      .attr('aria-expanded', 'false')
      .end()
      .find('.mcFilterDrawer')
      .attr('aria-hidden', 'true');
    $('body').removeClass('mc-filter-drawer-open');
  }

  function reopenFilterGroup() {
    var group = getRememberedFilterGroup();
    var $panel;

    if (!group) {
      return;
    }

    $panel = getPanel(group);

    if ($panel.length) {
      openPanel($panel, true);
    }
  }

  function updateSortArrowPosition() {
    var $select = $('#sidebarAjaxFilter.mcFilter #SortBy');
    var select = $select.get(0);
    var sortWrapper;
    var selectedText;
    var styles;
    var $measure;
    var textWidth;

    if (!select) {
      return;
    }

    selectedText = $.trim($select.find('option:selected').text());
    styles = window.getComputedStyle(select);
    $measure = $('<span aria-hidden="true"></span>')
      .text(selectedText)
      .css({
        position: 'absolute',
        visibility: 'hidden',
        whiteSpace: 'nowrap',
        fontFamily: styles.fontFamily,
        fontSize: styles.fontSize,
        fontStyle: styles.fontStyle,
        fontWeight: styles.fontWeight,
        letterSpacing: styles.letterSpacing,
        lineHeight: styles.lineHeight
      })
      .appendTo(document.body);

    textWidth = Math.ceil($measure.outerWidth());
    $measure.remove();

    sortWrapper = $select.closest('.collSortBy').get(0);
    sortWrapper.style.setProperty('--mc-sort-arrow-left', textWidth + 20 + 'px');
    sortWrapper.classList.add('is-sort-arrow-ready');
  }

  function getHeaderBottom() {
    var header = document.getElementById('velaHeader');

    if (!header || !header.classList.contains('headerFixed')) {
      return 0;
    }

    return Math.max(0, Math.ceil(header.getBoundingClientRect().bottom));
  }

  function getFilterRowPlaceholder($row) {
    var $placeholder = $row.prev('.mcFilterRowPlaceholder');

    if (!$placeholder.length) {
      $placeholder = $('<div class="mcFilterRowPlaceholder" aria-hidden="true"></div>');
      $placeholder.insertBefore($row);
    }

    return $placeholder;
  }

  function resetFixedFilterRow($row, $placeholder) {
    $row
      .removeClass('is-fixed')
      .get(0)
      .style.removeProperty('--mc-filter-fixed-top');
    $row.get(0).style.removeProperty('--mc-filter-fixed-left');
    $row.get(0).style.removeProperty('--mc-filter-fixed-width');
    $placeholder.removeClass('is-active').css('height', 0);
  }

  function updateFixedFilterRow() {
    var filter = document.querySelector('#sidebarAjaxFilter.mcFilter');
    var $row = $('#sidebarAjaxFilter.mcFilter .mcFilterRow').first();
    var row = $row.get(0);
    var $placeholder;
    var headerBottom;
    var markerTop;
    var filterRect;

    if (!filter || !row) {
      return;
    }

    $placeholder = getFilterRowPlaceholder($row);

    if (!window.matchMedia || !window.matchMedia('(min-width: ' + fixedFilterMinWidth + 'px)').matches) {
      resetFixedFilterRow($row, $placeholder);
      return;
    }

    headerBottom = getHeaderBottom();
    markerTop = ($row.hasClass('is-fixed') ? $placeholder.get(0) : row).getBoundingClientRect().top;

    if (markerTop > headerBottom) {
      resetFixedFilterRow($row, $placeholder);
      return;
    }

    filterRect = filter.getBoundingClientRect();
    row.style.setProperty('--mc-filter-fixed-top', headerBottom + 'px');
    row.style.setProperty('--mc-filter-fixed-left', Math.round(filterRect.left) + 'px');
    row.style.setProperty('--mc-filter-fixed-width', Math.round(filterRect.width) + 'px');
    $row.addClass('is-fixed');
    $placeholder.addClass('is-active').css('height', Math.ceil($row.outerHeight(true)) + 'px');
  }

  function requestFixedFilterRowUpdate() {
    if (fixedFilterFrame) {
      return;
    }

    fixedFilterFrame = window.requestAnimationFrame(function() {
      fixedFilterFrame = null;
      updateFixedFilterRow();
    });
  }

  function syncFixedFilterRowSoon() {
    requestFixedFilterRowUpdate();
    window.setTimeout(updateFixedFilterRow, 60);
    window.setTimeout(updateFixedFilterRow, 180);
    window.setTimeout(updateFixedFilterRow, 360);
  }

  $(document).on('click', '#sidebarAjaxFilter.mcFilter .ajaxFilterTitle', function(event) {
    event.preventDefault();

    var group = $(this).data('filter-group');
    var $panel = getPanel(group);
    var isOpen = $panel.hasClass('is-open');

    rememberFilterGroup(isOpen ? null : group);

    if (isOpen) {
      closePanel($panel);
    } else {
      openPanel($panel, false);
    }
  });

  $(document).on('click', '#sidebarAjaxFilter.mcFilter .mcFilterPanels .listFilter a, #sidebarAjaxFilter.mcFilter .mcFilterMobileGroups .listFilter a', function() {
    rememberFilterGroup($(this).closest('.mcFilterPanel').data('filter-group'));
  });

  $(document).on('click', '#sidebarAjaxFilter.mcFilter .mcFilterColours .listFilter a, #sidebarAjaxFilter.mcFilter .velaClearAll', function() {
    rememberFilterGroup(null);
    closeAllPanels();
  });

  $(document).on('click', '#sidebarAjaxFilter.mcFilter .mcFilterMobileToggle', function() {
    openDrawer();
  });

  $(document).on('change', '#sidebarAjaxFilter.mcFilter #SortBy', function() {
    updateSortArrowPosition();
  });

  $(document).on('click', '#sidebarAjaxFilter.mcFilter .mcFilterDrawerClose, #sidebarAjaxFilter.mcFilter .mcFilterDrawerOverlay', function() {
    closeDrawer();
  });

  $(document).on('keyup', function(event) {
    if (event.key === 'Escape') {
      closeDrawer();
    }
  });

  $(document).ajaxComplete(function() {
    window.setTimeout(function() {
      closeDrawer();
      reopenFilterGroup();
      updateSortArrowPosition();
      syncFixedFilterRowSoon();
    }, transitionBuffer);
  });

  $(window).on('scroll resize', function() {
    $('#sidebarAjaxFilter.mcFilter .mcFilterPanel.is-open').each(function() {
      setPanelHeight($(this));
    });
    updateSortArrowPosition();
    requestFixedFilterRowUpdate();
  });

  $(function() {
    updateSortArrowPosition();
    updateFixedFilterRow();
  });
})(window.jQuery);
